/**
 * @Author: abbeymart | Abi Akindele | @Created: 2021-07-09
 * @Company: Copyright 2021 Abi Akindele  | mConnect.biz
 * @License: All Rights Reserved | LICENSE.md
 * @Description: application routes
 */

import type { RouteRecordRaw } from 'vue-router';

export const appRoutes: Array<RouteRecordRaw> = [
  {
    path: '/app',
    name: 'app',
    redirect: '/app/list',
    component: () => import('pages/central/app/McApplication.vue'),
    meta: {
      title: 'Applications [Solutions]',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'appList',
        component: () => import('pages/central/app/ApplicationList.vue'),
        meta: {
          title: 'Applications List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'appDetail',
        component: () => import('pages/central/app/ApplicationDetail.vue'),
        meta: {
          title: 'Application Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'appNew',
        component: () => import('pages/central/app/ApplicationNew.vue'),
        meta: {
          title: 'New Application',
          requiresAuth: true,
        },
      },
    ],
  },
];
